import { render } from "./index.vue?vue&type=template&id=5c7ca812"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/banners-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c7ca812"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c7ca812', __exports__)) {
    api.reload('5c7ca812', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5c7ca812", () => {
    api.rerender('5c7ca812', render)
  })

}


export default __exports__